import axios from 'axios'
import React from 'react'
import { baseUrl } from '../assets/Animations'
import { getRequestHeaders } from '../api'
import './income-projections.css'

const IncomeProjections = () => {
    const [timesheets, setTimesheets] = React.useState([])
    const [invoices, setInvoices] = React.useState([])
    const [students, setStudents] = React.useState([])
    const [tableHeaders, setTableHeaders] = React.useState([])
    const schoolList = ['mma', 'lsma', 'tma', 'mor', 'psma', 'tem']
    const schoolOrder = ['mma', 'lsma', 'tma', 'mor', 'psma']
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    React.useEffect(() => {
        axios.get(`${baseUrl}/getalltimesheetsendpoint`, getRequestHeaders())
        .then(res => {
            setTimesheets(res.data)
        })
        .catch(err => {
            console.log(err)
        })
        axios.get(`${baseUrl}/allinvoices`, getRequestHeaders())
        .then(res => {
            setInvoices(res.data)
            console.log(createTableHeaders(res.data))
            setTableHeaders(createTableHeaders(res.data))
        })
        .catch(err => {
            console.log(err)
        })
        axios.get(`${baseUrl}/school-management`, getRequestHeaders())
        .then(res => {
            setStudents(Array.isArray(res.data) ? res.data : [])
        })
        .catch(err => {
            console.log(err)
        })
    },[])

    const resolveMonthYearFromTimesheet = (timesheet) => {
        if (!timesheet) return null
        if (timesheet.monthNumber && timesheet.year) {
            return { month: Number(timesheet.monthNumber), year: Number(timesheet.year) }
        }
        if (timesheet.monthYear && String(timesheet.monthYear).includes('/')) {
            const [m, y] = String(timesheet.monthYear).split('/')
            return { month: Number(m), year: Number(y) }
        }
        if (timesheet.month && timesheet.year) {
            const monthIndex = monthNames.findIndex((name) => name.toLowerCase() === String(timesheet.month).toLowerCase())
            if (monthIndex >= 0) {
                return { month: monthIndex + 1, year: Number(timesheet.year) }
            }
            const parsedMonth = Number(timesheet.month)
            if (!Number.isNaN(parsedMonth)) {
                return { month: parsedMonth, year: Number(timesheet.year) }
            }
        }
        return null
    }

    const resolveMonthYearFromInvoice = (invoice) => {
        if (!invoice) return null
        if (invoice.monthNumber && invoice.year) {
            return { month: Number(invoice.monthNumber), year: Number(invoice.year) }
        }
        if (invoice.monthYear && String(invoice.monthYear).includes('/')) {
            const [m, y] = String(invoice.monthYear).split('/')
            return { month: Number(m), year: Number(y) }
        }
        return null
    }

    const findFamilyForInvoice = (invoice) => {
        if (!invoice?.waveCustomerId) return null
        return students.find((student) => student.waveCustomerId === invoice.waveCustomerId) || null
    }

    const findStudentRate = (invoice, lesson, nameOnInvoice, lengthOfLesson) => {
        let found = false
        if (parseInt(lengthOfLesson) === 31 || parseInt(lengthOfLesson) === 46 || parseInt(lengthOfLesson) === 61 || parseInt(lengthOfLesson) === 32 || parseInt(lengthOfLesson) === 47 || parseInt(lengthOfLesson) === 62) {
            found = true
            if (parseInt(lengthOfLesson) === 31) {
                return 25
            } else if (parseInt(lengthOfLesson) === 46) {
                return 35
            } else if (parseInt(lengthOfLesson) === 61) {
                return 45
            } else if (parseInt(lengthOfLesson) === 32) {
                return 0
            } else if (parseInt(lengthOfLesson) === 47) {
                return 0
            } else if (parseInt(lengthOfLesson) === 62) {
                return 0
            }
        } else {
            if (lesson?.studentAllRates) {
                return lesson.studentAllRates[lengthOfLesson]
            } else if (invoice?.familyInfo?.students?.length) {
                for (let i = 0; i < invoice.familyInfo.students.length; i++) {
                    if (invoice.familyInfo.students[i].studentName === nameOnInvoice) {
                        found = true
                        if (!invoice.familyInfo.students[i].allRates) {
                            return invoice.familyInfo.students[i].lessonRate
                        } else {
                            return invoice.familyInfo.students[i].allRates[lengthOfLesson]
                        }
                    }
                }
            }
        }
        if (!found) {
            return 0
        }
    }

    const calculateEstimatedPayAgain = (theTimesheet) => {
        let minutesTaught = 0
        let allExtras = 0
        const families = Array.isArray(theTimesheet?.families) ? theTimesheet.families : []
        for (let i = 0; i < families.length; i++) {
            let fam = families[i]
            for (let j = 0; j < fam.lessons.length; j++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[j].lessonLength)
            }
            for (let j = 0; j < fam.cancellations.length; j++) {
                if (fam.cancellations[j].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[j].lessonLength)
                }
            }
            for (let j = 0; j < fam.extras.length; j++) {
                allExtras = Number(allExtras) + Number(fam.extras[j].amount)
            }
        }
        return ((minutesTaught/60) * Number(theTimesheet.teacherRate || 0)) + allExtras
    }

    const getCancellationStats = (monthlyTimesheets) => {
        let studentCount = 0
        let teacherCount = 0
        let chargedCount = 0
        let studentLoss = 0
        let teacherLoss = 0
        monthlyTimesheets.forEach((sheet) => {
            const families = Array.isArray(sheet?.families) ? sheet.families : []
            families.forEach((family) => {
                const cancellations = Array.isArray(family?.cancellations) ? family.cancellations : []
                const familyStudents = Array.isArray(family?.listOfFamilyStudents) ? family.listOfFamilyStudents : []
                cancellations.forEach((cancellation) => {
                    if (cancellation.cancellor === 'student') {
                        const studentName = cancellation.student
                        studentCount++
                        familyStudents.forEach((stu) => {
                            if (stu.studentName === studentName) {
                                if (!stu.allRates) {
                                    studentLoss += Number(stu.lessonRate || 0)
                                } else {
                                    const lengthNumber = stu.lessonLength
                                    studentLoss += Number(stu.allRates?.[lengthNumber] || 0)
                                }
                            }
                        })
                    } else if (cancellation.cancellor === 'teacher') {
                        const studentName = cancellation.student
                        teacherCount++
                        familyStudents.forEach((stu) => {
                            if (stu.studentName === studentName) {
                                if (!stu.allRates) {
                                    teacherLoss += Number(stu.lessonRate || 0)
                                } else {
                                    const lengthNumber = stu.lessonLength
                                    teacherLoss += Number(stu.allRates?.[lengthNumber] || 0)
                                }
                            }
                        })
                    } else if (cancellation.cancellor === 'student less than 24hrs') {
                        chargedCount++
                    }
                })
            })
        })
        return {
            studentCancellations: studentCount,
            teacherCancellations: teacherCount,
            chargedCancellations: chargedCount,
            studentRevenueLoss: Math.round(studentLoss),
            teacherRevenueLoss: Math.round(teacherLoss),
        }
    }

    const getLessonStats = (monthlyTimesheets) => {
        let lessonCounter = 0
        let hourCounter = 0
        let studentCounter = 0
        const studentHash = {}
        monthlyTimesheets.forEach((sheet) => {
            const families = Array.isArray(sheet?.families) ? sheet.families : []
            families.forEach((family) => {
                const lessons = Array.isArray(family?.lessons) ? family.lessons : []
                lessons.forEach((lesson) => {
                    hourCounter += Number(lesson.lessonLength || 0)
                    const studentName = lesson.studentName
                    if (studentName && !studentHash[studentName]) {
                        studentHash[studentName] = true
                        studentCounter++
                    }
                    lessonCounter++
                })
            })
        })
        const hoursTaught = hourCounter / 60
        const avgLessonsPerStudent = studentCounter ? Math.round((lessonCounter / studentCounter) * 100) / 100 : 0
        return {
            totalLessonsGiven: lessonCounter,
            totalHoursOfLessonsGiven: Math.round(hoursTaught * 100) / 100,
            studentsTaught: studentCounter,
            averageLessonsPerStudent: avgLessonsPerStudent,
        }
    }

    const getAverageLessonHourlyCost = (monthlyInvoices) => {
        let totalRevenue = 0
        let totalHoursTaught = 0
        monthlyInvoices.forEach((invoice) => {
            const lessons = Array.isArray(invoice?.lessonsToBeBilled) ? invoice.lessonsToBeBilled : []
            lessons.forEach((lesson) => {
                const len = String(parseInt(lesson.lessonLength))
                if (!len) return
                if (lesson.studentAllRates) {
                    totalRevenue += Number(lesson.studentAllRates[len] || 0)
                    if (len === '30') totalHoursTaught += 0.5
                    if (len === '45') totalHoursTaught += 0.75
                    if (len === '60') totalHoursTaught += 1
                    if (len === '15') totalHoursTaught += 0.25
                }
            })
        })
        if (!totalHoursTaught) return 0
        return Math.round((totalRevenue / totalHoursTaught) * 100) / 100
    }

    const buildMonthlySummaries = React.useMemo(() => {
        const monthMap = new Map()
        const ensureEntry = (month, year) => {
            const key = `${year}-${month}`
            if (!monthMap.has(key)) {
                monthMap.set(key, {
                    key,
                    month,
                    year,
                    timesheets: [],
                    invoices: [],
                })
            }
            return monthMap.get(key)
        }

        timesheets.forEach((sheet) => {
            const resolved = resolveMonthYearFromTimesheet(sheet)
            if (!resolved) return
            ensureEntry(resolved.month, resolved.year).timesheets.push(sheet)
        })

        invoices.forEach((invoice) => {
            const resolved = resolveMonthYearFromInvoice(invoice)
            if (!resolved) return
            const entry = ensureEntry(resolved.month, resolved.year)
            const familyInfo = findFamilyForInvoice(invoice)
            entry.invoices.push({ ...invoice, familyInfo })
        })

        const summaries = Array.from(monthMap.values()).map((entry) => {
            const cancellationStats = getCancellationStats(entry.timesheets)
            const lessonStats = getLessonStats(entry.timesheets)
            const lessonStatsBySchool = {}
            schoolList.forEach((school) => {
                lessonStatsBySchool[school] = getLessonStats(
                    entry.timesheets.filter((sheet) => sheet.school === school)
                )
            })
            const totalToChargeBySchool = {}
            const totalPayoutBySchool = {}
            schoolList.forEach((school) => {
                totalToChargeBySchool[school] = 0
                totalPayoutBySchool[school] = 0
            })

            entry.invoices.forEach((invoice) => {
                if (!invoice?.waveCustomerId || invoice.status === 'Scholarship') return
                const school = invoice.school
                if (!school || !totalToChargeBySchool.hasOwnProperty(school)) return
                const lessons = Array.isArray(invoice.lessonsToBeBilled) ? invoice.lessonsToBeBilled : []
                const extras = Array.isArray(invoice.extrasToBeBilled) ? invoice.extrasToBeBilled : []
                lessons.forEach((lesson) => {
                    totalToChargeBySchool[school] += Number(findStudentRate(invoice, lesson, lesson.studentName, lesson.lessonLength) || 0)
                })
                extras.forEach((extra) => {
                    totalToChargeBySchool[school] += Number(extra.amount || 0)
                })
            })

            entry.timesheets.forEach((sheet) => {
                const school = sheet.school
                if (!school || !totalPayoutBySchool.hasOwnProperty(school)) return
                totalPayoutBySchool[school] += Math.floor(Number(calculateEstimatedPayAgain(sheet) || 0))
            })

            const totalToCharge = schoolList.reduce((sum, school) => sum + totalToChargeBySchool[school], 0)
            const totalPayout = schoolList.reduce((sum, school) => sum + totalPayoutBySchool[school], 0)
            const averageLessonHourlyCost = getAverageLessonHourlyCost(entry.invoices)
            const averageTeacherHourlyRate = lessonStats.totalHoursOfLessonsGiven
                ? Math.round(((totalPayout / lessonStats.totalHoursOfLessonsGiven) * 100) / 100)
                : 0

            return {
                ...entry,
                cancellationStats,
                lessonStats,
                lessonStatsBySchool,
                totalToChargeBySchool,
                totalPayoutBySchool,
                totalToCharge,
                totalPayout,
                averageLessonHourlyCost,
                averageTeacherHourlyRate,
            }
        })

        summaries.sort((a, b) => (a.year - b.year) || (a.month - b.month))
        return summaries
    }, [invoices, timesheets, students])

    const monthColumnHeaders = React.useMemo(() => {
        const byMonth = new Map()
        buildMonthlySummaries.forEach((entry) => {
            const monthKey = entry.month
            if (!byMonth.has(monthKey)) byMonth.set(monthKey, [])
            byMonth.get(monthKey).push(entry)
        })
        const headers = []
        monthNames.forEach((name, idx) => {
            const monthKey = idx + 1
            const entries = byMonth.get(monthKey) || []
            entries.sort((a, b) => a.year - b.year)
            entries.forEach((entry) => {
                headers.push({
                    key: entry.key,
                    label: `${name} ${entry.year}`,
                    monthIndex: monthKey,
                })
            })
        })
        return headers
    }, [buildMonthlySummaries, monthNames])

    const monthGroupStartKeys = React.useMemo(() => {
        const starts = new Set()
        monthColumnHeaders.forEach((header, idx) => {
            if (idx === 0) {
                starts.add(header.key)
                return
            }
            const prev = monthColumnHeaders[idx - 1]
            if (prev.monthIndex !== header.monthIndex) {
                starts.add(header.key)
            }
        })
        return starts
    }, [monthColumnHeaders])

    const summaryByKey = React.useMemo(() => {
        const map = new Map()
        buildMonthlySummaries.forEach((entry) => map.set(entry.key, entry))
        return map
    }, [buildMonthlySummaries])

    function createTableHeaders(invoices) {
        const uniqueHeaders = new Set();
      
        invoices.forEach(invoice => {
          const monthNumber = invoice.monthNumber;
          const year = invoice.year;
          const monthYearKey = `${monthNumber}-${year}`;
      
          if (!uniqueHeaders.has(monthYearKey)) {
            uniqueHeaders.add(monthYearKey);
          }
        });
      
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        
        const headersArray = Array.from(uniqueHeaders).map(key => {
          const [month, year] = key.split('-');
          return {
            title: `${monthNames[parseInt(month) - 1]} ${year}`,
            month: parseInt(month),
            year: parseInt(year)
          };
        });
      
        // Sort the array by year first, then by month
        headersArray.sort((a, b) => {
          if (a.year !== b.year) {
            return a.year - b.year;
          }
          return a.month - b.month;
        });
      
        return headersArray;
      }

    return (
        <div className="income-projections">
            <div className="income-projections__header">
                <div className="income-projections__title">Billing Dashboard</div>
                <div className="income-projections__subtitle">Monthly owner overview</div>
            </div>
            <div className="income-projections__section-title">All Schools</div>
            <div className="income-projections__table-wrap">
                <table className="income-projections__table">
                    <thead>
                        <tr>
                            <th className="income-projections__sticky-col">Metric</th>
                            {monthColumnHeaders.map((header) => (
                                <th
                                    key={header.key}
                                    className={
                                        monthGroupStartKeys.has(header.key)
                                            ? "income-projections__group-start"
                                            : ""
                                    }
                                >
                                    {header.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="income-projections__sticky-col"># of lessons</td>
                            {monthColumnHeaders.map((header) => {
                                const entry = summaryByKey.get(header.key)
                                return (
                                    <td
                                        key={header.key}
                                        className={
                                            monthGroupStartKeys.has(header.key)
                                                ? "income-projections__group-start"
                                                : ""
                                        }
                                    >
                                        {entry?.lessonStats?.totalLessonsGiven || 0}
                                    </td>
                                )
                            })}
                        </tr>
                        <tr>
                            <td className="income-projections__sticky-col">Hours taught</td>
                            {monthColumnHeaders.map((header) => {
                                const entry = summaryByKey.get(header.key)
                                return (
                                    <td
                                        key={header.key}
                                        className={
                                            monthGroupStartKeys.has(header.key)
                                                ? "income-projections__group-start"
                                                : ""
                                        }
                                    >
                                        {entry?.lessonStats?.totalHoursOfLessonsGiven || 0}
                                    </td>
                                )
                            })}
                        </tr>
                        <tr>
                            <td className="income-projections__sticky-col">Avg lesson length</td>
                            {monthColumnHeaders.map((header) => {
                                const entry = summaryByKey.get(header.key)
                                const totalLessons = entry?.lessonStats?.totalLessonsGiven || 0
                                const totalHours = entry?.lessonStats?.totalHoursOfLessonsGiven || 0
                                const avgLength = totalLessons
                                    ? Math.round(((totalHours * 60) / totalLessons) * 100) / 100
                                    : 0
                                return (
                                    <td
                                        key={header.key}
                                        className={
                                            monthGroupStartKeys.has(header.key)
                                                ? "income-projections__group-start"
                                                : ""
                                        }
                                    >
                                        {avgLength}
                                    </td>
                                )
                            })}
                        </tr>
                        <tr>
                            <td className="income-projections__sticky-col">Students</td>
                            {monthColumnHeaders.map((header) => {
                                const entry = summaryByKey.get(header.key)
                                return (
                                    <td
                                        key={header.key}
                                        className={
                                            monthGroupStartKeys.has(header.key)
                                                ? "income-projections__group-start"
                                                : ""
                                        }
                                    >
                                        {entry?.lessonStats?.studentsTaught || 0}
                                    </td>
                                )
                            })}
                        </tr>
                        <tr>
                            <td className="income-projections__sticky-col">Avg lessons per student</td>
                            {monthColumnHeaders.map((header) => {
                                const entry = summaryByKey.get(header.key)
                                return (
                                    <td
                                        key={header.key}
                                        className={
                                            monthGroupStartKeys.has(header.key)
                                                ? "income-projections__group-start"
                                                : ""
                                        }
                                    >
                                        {entry?.lessonStats?.averageLessonsPerStudent || 0}
                                    </td>
                                )
                            })}
                        </tr>
                    </tbody>
                </table>
            </div>
            {schoolOrder.map((school) => (
                <div key={school}>
                    <div className="income-projections__section-title">{school.toUpperCase()}</div>
                    <div className="income-projections__table-wrap">
                    <table className="income-projections__table">
                        <thead>
                            <tr>
                                <th className="income-projections__sticky-col">Metric</th>
                                {monthColumnHeaders.map((header) => (
                                    <th
                                        key={`${school}-${header.key}`}
                                        className={
                                            monthGroupStartKeys.has(header.key)
                                                ? "income-projections__group-start"
                                                : ""
                                        }
                                    >
                                        {header.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="income-projections__sticky-col"># of lessons</td>
                                {monthColumnHeaders.map((header) => {
                                    const entry = summaryByKey.get(header.key)
                                    return (
                                        <td
                                            key={`${school}-lessons-${header.key}`}
                                            className={
                                                monthGroupStartKeys.has(header.key)
                                                    ? "income-projections__group-start"
                                                    : ""
                                            }
                                        >
                                            {entry?.lessonStatsBySchool?.[school]?.totalLessonsGiven || 0}
                                        </td>
                                    )
                                })}
                            </tr>
                            <tr>
                                <td className="income-projections__sticky-col">Hours taught</td>
                                {monthColumnHeaders.map((header) => {
                                    const entry = summaryByKey.get(header.key)
                                    return (
                                        <td
                                            key={`${school}-hours-${header.key}`}
                                            className={
                                                monthGroupStartKeys.has(header.key)
                                                    ? "income-projections__group-start"
                                                    : ""
                                            }
                                        >
                                            {entry?.lessonStatsBySchool?.[school]?.totalHoursOfLessonsGiven || 0}
                                        </td>
                                    )
                                })}
                            </tr>
                            <tr>
                                <td className="income-projections__sticky-col">Avg lesson length</td>
                                {monthColumnHeaders.map((header) => {
                                    const entry = summaryByKey.get(header.key)
                                    const stats = entry?.lessonStatsBySchool?.[school]
                                    const totalLessons = stats?.totalLessonsGiven || 0
                                    const totalHours = stats?.totalHoursOfLessonsGiven || 0
                                    const avgLength = totalLessons
                                        ? Math.round(((totalHours * 60) / totalLessons) * 100) / 100
                                        : 0
                                    return (
                                        <td
                                            key={`${school}-avglen-${header.key}`}
                                            className={
                                                monthGroupStartKeys.has(header.key)
                                                    ? "income-projections__group-start"
                                                    : ""
                                            }
                                        >
                                            {avgLength}
                                        </td>
                                    )
                                })}
                            </tr>
                            <tr>
                                <td className="income-projections__sticky-col">Students</td>
                                {monthColumnHeaders.map((header) => {
                                    const entry = summaryByKey.get(header.key)
                                    return (
                                        <td
                                            key={`${school}-students-${header.key}`}
                                            className={
                                                monthGroupStartKeys.has(header.key)
                                                    ? "income-projections__group-start"
                                                    : ""
                                            }
                                        >
                                            {entry?.lessonStatsBySchool?.[school]?.studentsTaught || 0}
                                        </td>
                                    )
                                })}
                            </tr>
                            <tr>
                                <td className="income-projections__sticky-col">Avg lessons per student</td>
                                {monthColumnHeaders.map((header) => {
                                    const entry = summaryByKey.get(header.key)
                                    return (
                                        <td
                                            key={`${school}-avgless-${header.key}`}
                                            className={
                                                monthGroupStartKeys.has(header.key)
                                                    ? "income-projections__group-start"
                                                    : ""
                                            }
                                        >
                                            {entry?.lessonStatsBySchool?.[school]?.averageLessonsPerStudent || 0}
                                        </td>
                                    )
                                })}
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            ))}
        </div>
    )
}
export default IncomeProjections;
